import { Component } from 'react';

import './hanukkah-easter-egg.css';

class HanukkahEasterEgg extends Component {
  constructor(props) {
    super(props);

    this.dates = [
      {
        date: '2022-12-18',
        image_index: '1',
      },
      {
        date: '2022-12-19',
        image_index: '2',
      },
      {
        date: '2022-12-20',
        image_index: '3',
      },
      {
        date: '2022-12-21',
        image_index: '4',
      },
      {
        date: '2022-12-22',
        image_index: '5',
      },
      {
        date: '2022-12-23',
        image_index: '6',
      },
      {
        date: '2022-12-24',
        image_index: '7',
      },
      {
        date: '2022-12-25',
        image_index: '8',
      },
    ];

    this.state = {
      can_click_tree: true,
      showing_santa: false,
    };
  }

  getHanukkahImage() {
    const today = new Date();
    const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();

    for (const index in this.dates) {
      const currentData = this.dates[index];

      if (currentData.date === date) {
        return 'hannukah_' + currentData.image_index + '.svg';
      }
    }

    return 'hannukah_0.svg';
  }

  render() {
    const hanukkahImage = this.getHanukkahImage();

    const hanukkah = new URL(`../../../../../static/assets/easter-eggs/hanukkah/${hanukkahImage}`, import.meta.url)
      .href;

    return (
      <div>
        <img title="Happy Hanukkah!" alt="hanukkah_menora" className="hanukkah_menora" src={hanukkah}></img>
      </div>
    );
  }
}

export default HanukkahEasterEgg;
